import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useEffect, useMemo, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDown, faCircleUp, faTrash } from '@fortawesome/free-solid-svg-icons';
import styles from './ListaParticipante.module.css';
import servSolicitacaoAcesso from '../../services/login/servSolicitacaoAcesso';
import { AG_GRID_LOCALE_PT_BR } from './AgGridPTBR';

// #region Remover participante
const RemoverParticipante = ({ row, setRowData, setIsLoading }) => {
    return (
        <button className={styles.btnRemover} id="removerParticipante" onClick={() => onClickRemoverParticipante(row, setRowData, setIsLoading)}>
            <FontAwesomeIcon icon={faTrash} />
        </button>
    );
}

const onClickRemoverParticipante = async (row, setRowData, setIsLoading) => {
    let data = row.data;
    let setParticipantes = data.setParticip;
    let setParticipantesWF = data.setParticipFunctions;

    try {
        setIsLoading(true);

        const response = await servSolicitacaoAcesso.RemoverParticipanteDaSolicitacao(data.Id);

        let conteudo = response.Content;

        conteudo = conteudo.map(participante => {
            participante.id = participante.Id;
            return participante;
        });

        const formattedRowsWFunction = conteudo.map(element => {
            return {
                ...element,
                setParticip: setParticipantes,
                setParticipFunctions: setParticipantesWF
            }
        });

        setIsLoading(false);

        setParticipantes(conteudo);
        setParticipantesWF(formattedRowsWFunction);
        setRowData(formattedRowsWFunction);
    } catch (err) {
        setIsLoading(false);
        console.log(err);
    }
}
// #endregion

// #region Ordenar participantes
const Ordenador = ({ row, gridRef, setRowData, setIsLoading }) => {
    const iconeCfeOrdemAbatimento = handleIconCfeOrdemAbatimento(row, gridRef);

    return (
        <button className={styles.btnOrdenar} id="ordenarParticipante" onClick={(event) => onClickOrdenarParticipante(event, row, gridRef, setRowData, setIsLoading)}>
            {iconeCfeOrdemAbatimento}
        </button>
    )
}

const handleIconCfeOrdemAbatimento = (row, gridRef) => {
    const participantes = gridRef.current.props.rowData;
    const indexRowAtual = participantes.findIndex((participante) => participante.Id === row.data.Id);

    if (!participantes || participantes.length === 1) {
        return null;
    }

    if (indexRowAtual === 0) {
        return (
            <FontAwesomeIcon className={styles.downGrid} icon={faCircleDown} />
        );
    } else if (indexRowAtual === (participantes.length - 1)) {
        return (
            <FontAwesomeIcon className={styles.upGrid} icon={faCircleUp} />
        );
    } else {
        return (
            <div style={{ display: "flex" }}>
                <div id="upGrid">
                    <FontAwesomeIcon className={styles.upGrid} id='upGrid' style={{ marginRight: "5px" }} icon={faCircleUp} />
                </div>
                <div id="downGrid">
                    <FontAwesomeIcon className={styles.downGrid} id='downGrid' icon={faCircleDown} />
                </div>
            </div>
        );
    }
}

const onClickOrdenarParticipante = async (event, rowAtual, gridRef, setRowData, setIsLoading) => {
    const participantes = gridRef.current.props.rowData;

    if (participantes.length < 2) return;

    let rowAnterior = gridRef.current.api.getDisplayedRowAtIndex(rowAtual.rowIndex - 1);
    let proximaRow = gridRef.current.api.getDisplayedRowAtIndex(rowAtual.rowIndex + 1);
    let dto = montaDtoConformePosicaoDaLinha(event, rowAtual, rowAnterior, proximaRow, participantes);

    let setParticipantes = rowAtual.data.setParticip;
    let setParticipantesWF = rowAtual.data.setParticipFunctions;

    try {
        setIsLoading(true);

        const response = await servSolicitacaoAcesso.AtualizarOrdemAbatimentoEntreOsParticipantes(dto);

        let conteudo = response.Content;

        conteudo = conteudo.map(participante => {
            participante.id = participante.Id;
            return participante;
        });

        const formattedRowsWFunction = conteudo.map(element => {
            return {
                ...element,
                setParticip: setParticipantes,
                setParticipFunctions: setParticipantesWF
            }
        });

        setIsLoading(false)

        setParticipantes(conteudo);
        setParticipantesWF(formattedRowsWFunction);
        setRowData(formattedRowsWFunction);
    } catch (err) {
        setIsLoading(false);
        console.log(err);
    }
}

const montaDtoConformePosicaoDaLinha = (event, rowAtual, rowAnterior, proximaRow, participantes, gridRef) => {
    if (rowAtual.rowIndex === 0) {
        return dtoParticipanteAtualEProximo(rowAtual, proximaRow);
    }

    if (rowAtual.rowIndex === (participantes.length - 1)) {
        return dtoParticipanteAtualEAnterior(rowAtual, rowAnterior);
    }

    let elementoPai = event.target.parentElement;

    if (elementoPai.id === 'downGrid') {
        return dtoParticipanteAtualEProximo(rowAtual, proximaRow)
    } else {
        return dtoParticipanteAtualEAnterior(rowAtual, rowAnterior);
    }
}

const dtoParticipanteAtualEProximo = (rowAtual, proximaRow) => {
    return {
        CodigoParticipanteAtual: rowAtual.data.Id,
        OrdemAbatimentoPartAtual: rowAtual.data.OrdemAbatimento,
        CodigoParticipanteAlterar: proximaRow.data.Id,
        OrdemAbatimentoPartAlterar: proximaRow.data.OrdemAbatimento
    };
}

const dtoParticipanteAtualEAnterior = (rowAtual, rowAnterior) => {
    return {
        CodigoParticipanteAtual: rowAtual.data.Id,
        OrdemAbatimentoPartAtual: rowAtual.data.OrdemAbatimento,
        CodigoParticipanteAlterar: rowAnterior.data.Id,
        OrdemAbatimentoPartAlterar: rowAnterior.data.OrdemAbatimento
    };
}

const formatarInscricaoConcessionaria = (value) => {
    if (!value) return '';

    const raw = value
        .toString()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .slice(0, 14);

    const parte1 = raw.slice(0, 2);
    const parte2 = raw.slice(2, 5);
    const parte3 = raw.slice(5, 8);
    const parte4 = raw.slice(8, 12);
    const parte5 = raw.slice(12, 14).replace(/\D/g, '');

    let resultado = parte1;

    if (raw.length > 2) resultado += `.${parte2}`;
    if (raw.length > 5) resultado += `.${parte3}`;
    if (raw.length > 8) resultado += `/${parte4}`;
    if (raw.length > 12) resultado += `-${parte5}`;

    return resultado;
};

const ListaParticipante = ({ participantes, isTipoParticipacaoPorcentagem, setIsLoading }) => {
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const initialColumnDef = [
        { field: 'Id', headerName: 'Código', hide: true },
        { field: 'CodigoSolicitacaoAcesso', headerName: 'Orç. conexão', hide: true },
        { field: 'CodigoUC', headerName: 'UC Interna', minWidth: 150, flex: 1 },
        { field: 'CodigoUcExterna', headerName: 'UC Externa', minWidth: 160, flex: 1, hide: (params) => params.data?.TipoUcVinculada !== 2, valueFormatter: (params) => params.data?.TipoUcVinculada === 1 ? '-' : params.value },
        { field: 'PercAbatimento', headerName: 'Abatimento (%)', minWidth: 150, flex: 1, hide: !isTipoParticipacaoPorcentagem },
        { field: 'OrdemAbatimento', headerName: 'Ordem abatimento', minWidth: 160, flex: 1.1, hide: isTipoParticipacaoPorcentagem },
        {
            field: 'InscricaoConcessionaria',
            headerName: 'CNPJ Distribuidora recebedora',
            minWidth: 270,
            flex: 1,
            hide: (params) => params.data?.TipoUcVinculada !== 2,
            valueFormatter: (params) => params.data?.TipoUcVinculada === 1 ? '-' : formatarInscricaoConcessionaria(params.value)
        },
        { field: 'Ordenar', headerName: 'Ordenar', minWidth: 135, flex: 0.9, cellRenderer: (row) => <Ordenador row={row} gridRef={gridRef} setRowData={setRowData} setIsLoading={setIsLoading} />, hide: isTipoParticipacaoPorcentagem },
        { field: 'Remover', headerName: 'Remover', minWidth: 135, flex: 0.9, cellRenderer: (row) => <RemoverParticipante row={row} setRowData={setRowData} setIsLoading={setIsLoading} /> }
    ];
    const [columnDefs, setColumnDefs] = useState(initialColumnDef);
    const defaultColDef = {
        cellStyle: { border: 'none' }
    };
    const localeText = useMemo(() => {
        return AG_GRID_LOCALE_PT_BR;
    }, []);

    useEffect(() => {
        setRowData(participantes);
        setColumnDefs(initialColumnDef);
    }, [participantes, isTipoParticipacaoPorcentagem]);

    return (
        <>
            <div className="ag-theme-alpine-dark" style={{ height: 230 }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    rowHeight={40}
                    headerHeight={50}
                    localeText={localeText}
                />
            </div>
        </>
    );
}

export { ListaParticipante }